import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { get } from 'lodash';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ObservablesService } from '../Services/observables/observables';
import { tap } from 'rxjs/operators';
import { CarrierInformationService } from '../Services/carrier-information-service/carrier-information-service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
	@BlockUI() blockUI: NgBlockUI;
	pendingRequestsCount = 0;
	showAjaxLoader: boolean;
	remoteAction = false;
	method: string;
	constructor(
		private observablesService: ObservablesService,
		private carrierInformationService: CarrierInformationService
	) {
		this.observablesService.showAjaxLoader.subscribe((res) => {
			this.showAjaxLoader = res;
		});
	}

	isOnRecalculateRates() {
		return this.carrierInformationService.isRecalculating;
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			tap(
				(response: HttpEvent<any>) => {
					const action = get(req.body, 'info.action');
					const isRelevancy = action === 'Relevancy' || action === 'EditInfoWeFound';
					const isSubmitCustomPackage = action === 'SubmitCustomPackage';
					const ChoosePackageNote = action === 'ConsumerChoosePackage';
					const isPing = action === 'Ping';
					const isPreloaderState = get(req, 'data.metadata.page.state');
					this.remoteAction = req.body ? req.body.isRemoteAction : false;
					if (
						req.body &&
						req.body.isRemoteAction &&
						!isRelevancy &&
						!ChoosePackageNote &&
						!isPreloaderState &&
						!isPing &&
						action != 'SubmissionLoaderCheckForResults'
					) {
						this.pendingRequestsCount += 1;
						this.method = req.method;
						this.blockUI.start();
					}

					if (req.method && req.method === 'POST' && this.showAjaxLoader) {
						this.blockUI.start();
					}

					if (response instanceof HttpResponse) {
						if (
							this.remoteAction &&
							!isRelevancy &&
							!isPreloaderState &&
							!isPing &&
							response.url &&
							response.url.toLowerCase().indexOf('splunk') === -1 && // ignore splunk call
							response.url.toLowerCase().indexOf('doubleclick') === -1 && // ignore doubleclick call
							response.body.action != 'none'
						) {
							this.pendingRequestsCount -= 1;

							this.blockUI.reset();
						}

						if (
							response &&
							this.method === 'POST' &&
							response.url &&
							!isRelevancy &&
							!isSubmitCustomPackage &&
							response.url.toLowerCase().indexOf('splunk') === -1 && // ignore splunk call
							response.url.toLowerCase().indexOf('doubleclick') === -1 && // ignore doubleclick call
							!this.isOnRecalculateRates()
						) {
							setTimeout(() => {
								this.blockUI.reset();
							}, 50);
						}
					}
				},
				(err: any) => {
					const action = get(req.body, 'info.action');
					const isRelevancy = action === 'Relevancy' || action === 'EditInfoWeFound';
					const isPing = action === 'Ping';
					const isPreloaderState = get(req, 'data.metadata.page.state');
					if (err.url && err.url.toLowerCase().indexOf('splunk') > -1) {
						return;
					}
					this.blockUI.stop();
				}
			)
		);
	}
}
